import React from "react";
import { IconProps } from "../icon";

export const Hash_02Icon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M9.5 3l-3 18m11-18l-3 18m6-13h-17m16 8h-17"
    />
  </svg>
);
